<template>
  <section class="content">
    <!-- Cabecera de la página -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Venta No.: {{ venta.numcontrol }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="/">Home</a></li>
              <li class="breadcrumb-item active">Venta</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Contenido principal -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">

            <div class="card-body">
              <div class="row">
                <!-- Columna Cliente -->
                <div class="col-md-4 border-right">
                  <h5 class="text-primary mb-3"><i class="fas fa-user mr-2"></i>DATOS DEL CLIENTE</h5>
                  <dl>
                    <dt class="text-muted small uppercase">Nombre / Razón Social</dt>
                    <dd class="font-weight-bold">{{ venta.nombre_cliente }}</dd>

                    <dt class="text-muted small uppercase">RIF / C.I</dt>
                    <dd>{{ venta.cliente.rif }}</dd>

                    <dt class="text-muted small uppercase">Contacto</dt>
                    <dd>{{ venta.cliente.telefono || 'Sin teléfono' }}</dd>

                    <dt class="text-muted small uppercase">Dirección</dt>
                    <dd class="text-sm">{{ venta.cliente.direccion }}</dd>
                  </dl>
                </div>

                <!-- Columna Venta -->
                <div class="col-md-4 border-right">
                  <h5 class="text-primary mb-3"><i class="fas fa-file-invoice-dollar mr-2"></i>DETALLES VENTA</h5>
                  <div class="row">
                    <div class="col-6">
                      <dt class="text-muted small">No. Control</dt>
                      <dd class="badge badge-info">{{ venta.numcontrol }}</dd>
                    </div>
                    <div class="col-6">
                      <dt class="text-muted small">Tipo</dt>
                      <dd>{{ venta.tipo_pago }}</dd>
                    </div>
                    <div class="col-6">
                      <dt class="text-muted small">Fecha Venta</dt>
                      <dd>{{ venta.fecha_venta }}</dd>
                    </div>
                    <div class="col-6">
                      <dt class="text-muted small">Fecha Entrega</dt>
                      <dd>{{ venta.fecha_entrega }}</dd>
                    </div>
                  </div>
                </div>

                <!-- Columna Estatus y Documentos -->
                <div class="col-md-4">
                  <h5 class="text-primary mb-3"><i class="fas fa-info-circle mr-2"></i>ESTATUS Y ASIGNACIÓN</h5>
                  <dl class="row">
                    <div class="col-6">
                      <dt class="text-muted small">Pago</dt>
                      <dd>
                        <span :class="['badge', venta.status_pago === 'pagado' ? 'badge-success' : 'badge-warning']">
                          {{ venta.status_pago }}
                        </span>
                      </dd>
                    </div>
                    <div class="col-6">
                      <dt class="text-muted small">Logística</dt>
                      <dd>
                        <span
                          :class="['badge', venta.status_logistico === 'entregado' ? 'badge-success' : 'badge-primary']">
                          {{ venta.status_logistico }}
                        </span>
                      </dd>
                    </div>
                  </dl>

                  <!-- SECCIÓN DE DOCUMENTOS ADJUNTOS ACTUALIZADA -->
                  <dt class="text-muted small">Documentos Adjuntos</dt>
                  <dd v-if="venta.documentos && venta.documentos.length">
                    <div v-for="doc in venta.documentos" :key="doc.id" class="mb-2 btn-group btn-group-sm d-flex">
                      <!-- Botón para ver/abrir archivo -->
                      <a :href="doc.ruta_visualizacion" target="_blank" class="btn btn-outline-info text-truncate w-75"
                        :title="doc.nombre_original">
                        <i class="fas fa-file-pdf mr-1"></i> {{ doc.nombre_original }}
                      </a>
                      <!-- Botón para Compartir directo (WhatsApp/Nativo) -->
                      <button @click="compartirDocumento(doc)" class="btn btn-success w-25" title="Compartir archivo">
                        <i class="fab fa-whatsapp"></i>
                      </button>
                    </div>
                  </dd>
                  <dd v-else class="text-muted small">Sin documentos</dd>

                  <dt class="text-muted small">Vendedor</dt>
                  <dd><i class="fas fa-user-tie mr-1 text-secondary"></i> {{ venta.vendedor }}</dd>

                  <div v-if="venta.despacho && venta.despacho.responsable">
                    <dt class="text-muted small">Responsable de Entrega</dt>
                    <dd><i class="fas fa-truck mr-1 text-secondary"></i> {{ venta.despacho.responsable }}</dd>
                  </div>
                </div>
              </div>
            </div>

            <!-- Body: tabla de detalles -->
            <div class="card-body p-0 border-top">
              <div class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 12%;">Código</th>
                      <th>Descripción</th>
                      <th style="width: 20%;">Cantidad</th>
                      <th style="width: 12%;">Precio Unit.</th>
                      <th style="width: 10%;">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detalle, index) in detallesNoObsequio" :key="detalle.id || index" class="align-middle">
                      <td>{{ detalle.producto.codigo }}</td>
                      <td>{{ detalle.producto.descripcion }}</td>
                      <td>{{ formatCJyUN(detalle) }}</td>
                      <td>{{ '$' + (Number(detalle.precio_unit || 0) + Number(detalle.iva_producto || 0)).toFixed(2) }}
                      </td>
                      <td>{{ '$' + ((Number(detalle.precio_unit || 0) + Number(detalle.iva_producto || 0)) *
                        Number(detalle.cantidad || 0)).toFixed(2) }}</td>
                    </tr>

                    <tr v-if="!detallesNoObsequio.length">
                      <td colspan="5" class="text-center">No se encontraron detalles para esta venta.</td>
                    </tr>
                  </tbody>

                  <tfoot class="bg-light">
                    <tr v-if="venta.desc_total > 0">
                      <td colspan="4" class="text-right pr-4 text-muted">Subtotal:</td>
                      <td class="text-left font-weight-bold">${{ subtotal }}</td>
                    </tr>
                    <tr v-if="venta.desc_total > 0">
                      <td colspan="4" class="text-right pr-4 text-danger">Descuento:</td>
                      <td class="text-left text-danger font-weight-bold">-${{ venta.desc_total }}</td>
                    </tr>
                    <tr style="font-size: 1.2rem;">
                      <td colspan="4" class="text-right pr-4"><strong>TOTAL:</strong></td>
                      <td class="text-left text-primary"><strong>${{ total }}</strong></td>
                    </tr>
                    <tr v-if="obsequios.length">
                      <td colspan="5" class="pr-4">
                        <strong>Obsequios</strong>
                        <ul>
                          <li v-for="(o, i) in obsequios" :key="o.id || i">
                            {{ o.producto.codigo }} - {{ o.producto.descripcion }} — Cantidad: {{ o.cantidad_obsequio }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <!-- Footer: Botones principales -->
            <div class="card-footer d-flex justify-content-between bg-white py-3">
              <div>
                <button @click="showAnularModal = true" class="btn btn-danger mr-2"
                  :disabled="venta.status_logistico === 'anulado'">
                  Anular Venta
                </button>

                <router-link v-if="venta.status_logistico === 'pedido'"
                  :to="{ name: 'EditarVenta', params: { id: venta.id }, query: { modo: 'editar' } }"
                  class="btn btn-warning" title="Editar pedido">
                  <i class="fas fa-edit"></i> Editar Venta
                </router-link>
                <button v-else class="btn btn-secondary" disabled title="No se puede editar">
                  <i class="fas fa-edit"></i> Editar Venta
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal de anulación -->
    <div v-if="showAnularModal">
      <div class="modal-backdrop fade show"></div>
      <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5>Anular Venta</h5>
              <button @click="showAnularModal = false" class="close">&times;</button>
            </div>
            <div class="modal-body">
              <div class="alert alert-danger alert-dismissible">
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                <h5><i class="icon fas fa-ban"></i> Alerta!</h5>
                Cuidado! Esta acción es irreversible, por favor verifica antes de continuar.
              </div>
              <div class="form-group">
                <label>Razón de la anulación (mín. 10 caracteres):</label>
                <textarea v-model="razonAnulacion" class="form-control" rows="2"
                  placeholder="Ej. El cliente decidió cancelar el pedido..."></textarea>
              </div>
              <div class="form-group mt-3">
                <label>Prueba/Acta de Anulación (PDF o Imagen):</label>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="actaFile" @change="handleFileUpload"
                    accept=".pdf,image/*">
                  <label class="custom-file-label" for="actaFile">
                    {{ archivoAnulacion ? archivoAnulacion.name : 'Seleccionar archivo...' }}
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button @click="showAnularModal = false" class="btn btn-secondary">Cancelar</button>
              <button @click="confirmarAnulacion" class="btn btn-danger">Confirmar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'VentaDetalle',
  props: {
    venta: { type: Object, required: false, default: () => ({ cliente: {}, detalles: [] }) }
  },
  data() {
    return {
      localVenta: this.venta || { cliente: {}, detalles: [] },
      showAnularModal: false,
      razonAnulacion: '',
      archivoAnulacion: null
    };
  },
  computed: {
    detallesNoObsequio() {
      return (this.localVenta.detalles || []).filter(d => Number(d.is_obsequio) !== 1);
    },
    obsequios() {
      return (this.localVenta.detalles || []).filter(d => Number(d.is_obsequio) === 1);
    },
    subtotal() {
      const s = this.detallesNoObsequio.reduce((sum, d) => {
        const precio = Number(d.precio_unit || 0) + Number(d.iva_producto || 0);
        return sum + precio * Number(d.cantidad || 0);
      }, 0);
      return s.toFixed(2);
    },
    total() {
      const desc = Number(this.localVenta.desc_total || 0);
      return (Number(this.subtotal) - desc).toFixed(2);
    },
    venta() {
      return this.localVenta;
    }
  },
  methods: {
    formatCJyUN(det) {
      const perCaja = det.producto?.cantxcaja || 1;
      const cajas = Math.floor((Number(det.cantidad) || 0) / perCaja);
      const unidades = (Number(det.cantidad) || 0) % perCaja;
      const partes = [];
      if (cajas > 0) partes.push(`${cajas} CJ`);
      if (unidades > 0) partes.push(`${unidades} UN`);
      return partes.length ? partes.join(' – ') : '0';
    },
    handleFileUpload(event) {
      this.archivoAnulacion = event.target.files[0];
    },
    confirmarAnulacion() {
      if (this.razonAnulacion.length < 10) {
        return alert('La razón debe tener al menos 10 caracteres.');
      }
      if (!this.archivoAnulacion) {
        return alert('Debes subir un archivo (PDF o Imagen) como prueba de anulación.');
      }

      const formData = new FormData();
      formData.append('razon', this.razonAnulacion);
      formData.append('acta_anulacion', this.archivoAnulacion);

      api.post(`/ventas/${this.localVenta.id}/anular`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          alert('Venta anulada correctamente.');
          this.showAnularModal = false;
          this.razonAnulacion = '';
          this.archivoAnulacion = null;
          this.localVenta.status_logistico = 'anulado';
        })
        .catch(err => {
          console.error('Error anulando venta:', err.response?.data || err);
          alert(err.response?.data?.message || 'Error al procesar la anulación.');
        });
    },

    imprimirVenta() {
      api.get(`/pdf/venta/${this.localVenta.id}`, { responseType: 'blob' })
        .then(({ data }) => {
          const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Venta_-${this.localVenta.numcontrol}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(err => {
          console.error('Error al generar PDF:', err);
        });
    },

    // 1. Método para compartir un documento adjunto ya existente
    async compartirDocumento(doc) {
      const texto = `REPORTE DE VENTA

No.: ${this.localVenta.numcontrol}
Fecha: ${this.localVenta.fecha_entrega}
Cliente: ${this.localVenta.nombre_cliente} 

Tipo de venta: ${this.localVenta.tipo_pago || 'No definido'}

OBSERVACIONES:`.trim();

      try {
        await navigator.clipboard.writeText(texto);

      } catch (err) {
        console.log('No se pudo copiar')
      }
      try {
        // Verificar si la API nativa de compartir soporta envío de archivos
        if (navigator.canShare && navigator.canShare({ files: [new File([], '')] })) {
          const response = await fetch(doc.ruta_visualizacion);
          const blob = await response.blob();

          const file = new File([blob], doc.nombre_original || 'documento.pdf', {
            type: blob.type || 'application/pdf'
          });

          await navigator.share({
            title: doc.nombre_original,
            text: `Te comparto el documento adjunto de la venta ${this.localVenta.numcontrol}`,
            files: [file]
          });
        } else {
          // Fallback: Si se abre desde un PC/Laptop enviar URL directa por WhatsApp Web
          const mensaje = encodeURIComponent(`Hola, te comparto el documento de la venta ${this.localVenta.numcontrol}: ${doc.ruta_visualizacion}`);
          window.open(`https://api.whatsapp.com/send?text=${mensaje}`, '_blank');
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error al compartir:', error);
          alert('No se pudo compartir el archivo directamente.');
        }
      }
    },

    // 2. Método para compartir la Factura PDF generada por la API en vivo
    async compartirPDFGenerado() {
      try {
        const { data } = await api.get(`/pdf/venta/${this.localVenta.id}`, { responseType: 'blob' });
        const nombrePdf = `Venta_${this.localVenta.numcontrol}.pdf`;

        if (navigator.canShare && navigator.canShare({ files: [new File([], '')] })) {
          const file = new File([data], nombrePdf, { type: 'application/pdf' });

          await navigator.share({
            title: `Venta #${this.localVenta.numcontrol}`,
            text: `Comprobante de Venta #${this.localVenta.numcontrol}`,
            files: [file]
          });
        } else {
          // Si es PC, se descarga o abre el PDF normalmente como fallback
          this.imprimirVenta();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error compartiendo PDF generado:', error);
          alert('Error al generar o compartir el archivo.');
        }
      }
    }
  },
  mounted() {
    if (!this.localVenta || !this.localVenta.id) {
      const id = this.$route.params.id;
      api.get(`/ventas/${id}`)
        .then(({ data: v }) => {
          this.localVenta = { ...v, cliente: v.cliente || v.cliente_ocasional || {}, detalles: v.detalles || [] };
          console.log('venta cargada:', v);
        })
        .catch((e) => console.error('Error cargando venta:', e));
    }
  }
};
</script>

<style scoped>
.table tfoot td {
  text-align: right !important;
}
</style>